/**
 * Admin > Algo Execution Monitor -- read-only diagnostic/audit view over
 * AlgoExecutionAudit rows. See `app.services.algo_execution_audit_service`
 * on the backend for what gets enriched and how.
 */
import api from "@/services/api";
import type { AlgoExecutionAuditDetail, AlgoExecutionAuditListResponse } from "@/types";

export interface AlgoExecutionAuditListParams {
  algo_id?: string;
  user_id?: string;
  broker_account_id?: string;
  status?: string;
  since?: string;
  until?: string;
  search?: string;
  failed_stage?: string;
  exclude_executed?: boolean;
  limit?: number;
  offset?: number;
}

export const algoExecutionAuditService = {
  async list(params: AlgoExecutionAuditListParams): Promise<AlgoExecutionAuditListResponse> {
    const { data } = await api.get<AlgoExecutionAuditListResponse>("/admin/algo-execution-audit", { params });
    return data;
  },

  async getDetail(auditId: string): Promise<AlgoExecutionAuditDetail> {
    const { data } = await api.get<AlgoExecutionAuditDetail>(`/admin/algo-execution-audit/${auditId}`);
    return data;
  },
};

export default algoExecutionAuditService;
